import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import { Box, Typography } from "@mui/material";
import chairman from "../Assets/Images/chairmenHome.jpg";
import commas from "../Assets/Images/inverted-commas.png";
import { motion } from "framer-motion";

const ChairmanMsg = () => { 
  return (
    <>
      <Box className="chairmanMsg" style={{ background: "#f3f6f7" }}>
        <Container>
          <motion.div
            initial={{ opacity: 0.5, y: 250 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, ease: "easeInOut" }}
            viewport={{ once: true }}
          >
            <Box className="mainMsg">
              <Image src={commas} className="img-fluid"></Image>
              <Row>
                <Col lg="8" style={{ padding: "40px" }}>
                  <Box className="msg">
                    <Typography variant="h6">
                      From The Desk of Chairman
                    </Typography>
                    <Typography
                      variant="body1"
                      component="p"
                      style={{ textAlign: "justify" }}
                    >
                      At Shankh Air, our vision is firmly grounded in making air
                      travel more seamless, accessible, and traveler-friendly
                      for people across the region and beyond. We are committed
                      to delivering fair, competitive fares, exceptional
                      customer service, and a consistently smooth flying
                      experience. Our mission is to transform the way people
                      view air travel—by making it practical, dependable, and
                      within reach for all. We uphold the highest standards of
                      quality and work tirelessly to earn the trust of every
                      passenger, on every journey. Shankh Air is here to
                      redefine what flying means—offering a simpler, more
                      reliable, and cost-effective travel experience so more
                      individuals and families can experience the comfort,
                      convenience, and freedom that air travel should always
                      offer.
                    </Typography>
                    <Typography variant="body1" component="p">
                      ~Sharvan Kumar Vishwakarma
                    </Typography>
                  </Box>
                </Col>
                <Col lg="4" className="cairmenImg">
                  <Image src={chairman} className="img-fluid"></Image>
                </Col>
              </Row>
              <Box className="chairOverlay"></Box>
            </Box>
          </motion.div>
        </Container>
      </Box>
    </>
  );
};

export default ChairmanMsg;
